import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DevicesPayload } from '../../equipment/devices/components/devices.models';
import { LOADER_CONTEXT } from '../../../services/interceptors/loader.interceptor';
import { DcuMtuCommunicationCountsResponse, DcuToMtuCommunicationResponse } from './dcu-to-mtu-communication.types';

@Injectable({ providedIn: 'root' })
export class DcuToMtuCommunicationApiService {
  private http = inject(HttpClient);

  getAll(payload: DevicesPayload): Observable<DcuToMtuCommunicationResponse> {
    return this.http.post<DcuToMtuCommunicationResponse>(`/api/network-monitoring/mtu-to-dcu-communication`, payload, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }

  getStatistics(payload: DevicesPayload): Observable<DcuMtuCommunicationCountsResponse> {
    return this.http.post<DcuMtuCommunicationCountsResponse>(
      `/api/network-monitoring/mtu-to-dcu-communication-counts`,
      payload,
      {
        context: new HttpContext().set(LOADER_CONTEXT, true)
      }
    );
  }
}
